import {ASSIGNED_REQUESTS} from "../../API/APIRoutes";
import GenericPendingExitRequests
    from "../RegulatoryMember/PendingExitRequestsFolder/GenericPendingExitRequests/GenericPendingExitRequests";

function AssignedRequestsListing() {
    return <GenericPendingExitRequests API={ASSIGNED_REQUESTS}  title = {"My Approvals History"} all ={true} readOnly ={true} cancelled={false}/>;
}

export default AssignedRequestsListing;
